var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button-v2 button-v2--primary button-v2--center button-v2--small",attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }